// extracted by mini-css-extract-plugin
export default {"textWrapper":"infoBodies_textWrapper__clfT4","textContent":"infoBodies_textContent__kkRMQ","title":"infoBodies_title__plEec"};